import React, { useRef, useState } from 'react'
import Button from '../components/Button'
import { BlocksRenderer } from '@strapi/blocks-react-renderer'

const ThemenModule = ({ module, sectionColor = "pink" }) => {
    const [activeTab, setActiveTab] = useState("tab1");

    const videoRef = useRef(null);
    const [play, setPlay] = useState(false);

    const playVideo = () => {
        setPlay(true);
    }

    const pauseVideo = () => {
        setPlay(false);
    }

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hovering, setHovering] = useState(false);

    const mouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();

        setPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    return (
        <section className={`pt-pb-10 sec-bg-grey sec-${sectionColor}-color sec-aenean-care`}>
            <div className='container'>
                {module?.Kurzen_Titel_erforderlich === "Ja" && module?.Kurztitel && <div className='subtitle'>{module?.Kurztitel}</div>}
                <div className='row'>
                    <div className='col-lg-4 tab-col'>
                        {module?.Titel && <h2 className='text-darkgrey mb-3'>{module?.Titel}</h2>}
                        <ul className="nav nav-tabs vertical-tabs">
                            {module?.Themen?.map((thema, index) => (
                                <li className="nav-item">
                                    <button className={`nav-link ${activeTab === `tab${index + 1}` ? "active" : ""}`} onClick={() => setActiveTab(`tab${index + 1}`)}>{thema?.Titel}</button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className='col-lg-8 tab-content-col'>
                        <div className="tab-content">
                            {module?.Themen?.map((thema, index) => (
                                <div key={index} className={`tab-pane ${activeTab === `tab${index + 1}` ? "active" : "d-none"}`}>
                                    <div className='tab-data-wrapper fw_strong_450 tick_list two_col'>

                                        {thema?.Bild_oder_Video !== "Video" ? (
                                            <>{thema?.Bild && <img src={`https://backend.bgzurlinden.ch${thema?.Bild[0]?.url}`} alt='Energie sparen & bewusst haushalten' className='w-100 mb-3' />}</>
                                        ) : (
                                            <div className={`video_thumbnail position-relative mb-3 ${hovering && play ? 'hide_cursor' : ''}`} onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)} onMouseMove={mouseMove}>

                                                {play && <video
                                                    ref={videoRef}
                                                    className="w-100 d-block pb-0"
                                                    // controls
                                                    autoPlay
                                                    playsInline
                                                    preload="metadata"
                                                    onClick={pauseVideo}
                                                    onEnded={pauseVideo}
                                                >
                                                    <source
                                                        src={`https://backend.bgzurlinden.ch${thema?.Video?.url}`}
                                                        type="video/mp4"
                                                    />
                                                </video>}

                                                {hovering && play && (
                                                    <div
                                                        className="video_image_cursor"
                                                        style={{
                                                            left: `${position.x}px`,
                                                            top: `${position.y}px`,
                                                        }}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                                                            <path d="M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60Z" fill={`var(--${sectionColor})`} fill-opacity="1" />
                                                            <rect x="47" y="38" width="8" height="45" fill="white" />
                                                            <rect x="66" y="38" width="8" height="45" fill="white" />
                                                        </svg>
                                                    </div>
                                                )}

                                                {!play && (
                                                    <>
                                                        <img
                                                            src={`https://backend.bgzurlinden.ch${thema?.Videominiatur?.url}`}
                                                            alt=''
                                                            className='video_overlay_img'
                                                        />

                                                        <button
                                                            type='button'
                                                            onClick={playVideo}
                                                            className='video_play_btn'
                                                        >
                                                            <svg className='icon_play' xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                                                                <circle cx="60" cy="60" r="60" fill={`var(--${sectionColor})`} />
                                                                <path d="M83 60L43 83L43 37L83 60Z" fill="white" />
                                                            </svg>
                                                        </button>
                                                    </>
                                                )}

                                            </div>
                                        )}

                                        {thema?.Text && <BlocksRenderer content={thema?.Text} />}

                                        <Button component={thema?.Komponente} pdf={thema?.PDF} buttons={thema?.Button} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ThemenModule